import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader, TableLoader } from "../../commons";
import ClientDirectoryTableData from "./ClientDirectoryTableData";
import ScrollToTop from "../../commons/ScrollToTop";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import { SendEmailPayload } from "../../../commonTypes/clientDirectoryTypes";
type AppProps = {
  offset: number;
  fetching: boolean;
  clientDirectoryList: [] | ClientDirectoryListType[];
  tableHeader: [] | TableHeadersType[];
  isEditClientPresent?: boolean;
  handleConfirmationModal: () => void;
  handleChangeClientStatusChangeData: (data: any) => void;
  handleEditClientDirectory: (clientCode: string) => void;
  handleViewClientDirectory: (clientCode: string) => void;
  isViewClientPresent: boolean;
  isViewOnlyClientPresent: boolean;
  handleToggleSentEmailToClient: () => void;
  handleSentEmailToClient: (data: SendEmailPayload) => void;
  handleSendEmail: (data: SendEmailPayload) => void;
  isEmailClientPresent: boolean;
};
const ClientDirectoryTable = ({
  offset,
  fetching,
  tableHeader,
  clientDirectoryList,
  isEditClientPresent,
  handleEditClientDirectory,
  handleViewClientDirectory,
  handleConfirmationModal,
  handleChangeClientStatusChangeData,
  isViewClientPresent,
  isViewOnlyClientPresent,
  handleToggleSentEmailToClient,
  handleSentEmailToClient,
  handleSendEmail,
  isEmailClientPresent,
}: AppProps) => {
  let viewTable = isViewOnlyClientPresent
    ? tableHeader?.length > 0
      ? tableHeader?.filter((el: any) => el?.value != "status")
      : tableHeader
    : tableHeader;
  return (
    <>
      {fetching && offset === 0 ? (
        <TableLoader Rows={7} ColumnPerRow={7} />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="table-bordered disbursment table-responsive" >
            <table className="table table-striped">
              <thead className=" sticky-table-header">
                <TableHeader tableHeader={viewTable} extraHeader />
              </thead>
              <tbody>
                <ClientDirectoryTableData
                  tableHeader={viewTable}
                  handleConfirmationModal={handleConfirmationModal}
                  handleChangeClientStatusChangeData={
                    handleChangeClientStatusChangeData
                  }
                  clientDirectoryList={clientDirectoryList}
                  handleEditClientDirectory={handleEditClientDirectory}
                  handleViewClientDirectory={handleViewClientDirectory}
                  isEditClientPresent={isEditClientPresent}
                  isViewClientPresent={isViewClientPresent}
                  handleToggleSentEmailToClient={handleToggleSentEmailToClient}
                  handleSentEmailToClient={handleSentEmailToClient}
                  handleSendEmail={handleSendEmail}
                  isEmailClientPresent={isEmailClientPresent}
                />
                {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default ClientDirectoryTable;
